var c=Object.defineProperty;var d=(a,b)=>c(a,"name",{value:b,configurable:!0});export{d as a};
//# sourceMappingURL=chunk-DYCPFO4Y.js.map
